import React from 'react'
import { Range } from '@medeo/components'

const BloodGlucoseTarget = () => [
  <Range
    min={0}
    key="fasting"
    label={'À jeun (g/L)'}
    max={200}
    step={1}
    color="#FF5D5D"
    items={[
      {
        low: 55,
        nameLow: 'fasting-verylow',
        high: 130,
        nameHigh: 'fasting-veryhigh',
        color: '#F19E40'
      },
      {
        low: 70,
        nameLow: 'fasting-low',
        high: 120,
        nameHigh: 'fasting-high',
        color: '#57DA92'
      }
    ]}
  />,
  <Range
    min={0}
    label="Midi (g/L)"
    max={200}
    step={1}
    key="midday"
    color="#FF5D5D"
    items={[
      {
        low: 55,
        nameLow: 'midday-verylow',
        high: 130,
        nameHigh: 'midday-veryhigh',
        color: '#F19E40'
      },
      {
        low: 70,
        nameLow: 'midday-low',
        high: 120,
        nameHigh: 'midday-high',
        color: '#57DA92'
      }
    ]}
  />,
  <Range
    min={0}
    max={200}
    step={1}
    key="evening"
    color="#FF5D5D"
    label="Soir (g/L)"
    items={[
      {
        low: 55,
        nameLow: 'evening-verylow',
        high: 130,
        nameHigh: 'evening-veryhigh',
        color: '#F19E40'
      },
      {
        low: 70,
        nameLow: 'evening-low',
        high: 120,
        nameHigh: 'evening-high',
        color: '#57DA92'
      }
    ]}
  />
]

export default BloodGlucoseTarget



// WEBPACK FOOTER //
// ./src/Goal/components/BloodGlucoseTarget.js